import { connect } from "react-redux";

import { Actions as EMPLOYEEACTIONS } from "../../../store/actions/employeeActions";
import { Actions as ACTIONS } from "../../../store/actions/noteActions";

import Spinner from "@/components/common/Spinner";
import Tooltip from "@/tooltip";
import { format, formatDistanceStrict } from "date-fns";
import IntegrationResyncEmployee from "../../integrations/IntegrationResyncEmployee";

import { copyToClipboard } from "@/helpers/ClipboardHelpers";
import * as OutlineIcons from "@/icons/outline";
import * as SolidIcons from "@/icons/solid";

const Employee = ({
	employee,
	agreementId,
	addNote,
	department,
	role,
	engagementDate,
	terminationDate,
	sendInvite,
	userPermissions,
	isAdmin,
	openMFAModal,
	mfaPermissions,
	mfaEnabled,
	employeeHasMFA,
	setUpStatus,
	sendingInvite,
	previouslySentInvite,
}) => {
	const employedFor = engagementDate
		? formatDistanceStrict(engagementDate, terminationDate || new Date(), {
				addSuffix: false,
				roundingMethod: "floor",
		  })
		: null;

	return (
		<div className="row">
			<div className="col-sm-12">
				<div className="pull-left">
					<h1 className="page-heading">
						{employee.employeeDetails?.givenName} {employee.employeeDetails?.familyName}
						<span style={{ fontSize: "1.5rem" }}>
							({employee.employeeDetails?.identificationNumbers?.[0]?.no})
						</span>
					</h1>
					<div>
						{(engagementDate && format(engagementDate, "do MMMM yyyy")) || ""} -{" "}
						{terminationDate ? `${format(terminationDate, "do MMMM yyyy")}` : "Indefinite"} ({employedFor})
					</div>
					<div>
						{role?.name}
						{department && " - "}
						{department?.departmentName || department?.name}
					</div>
				</div>

				<div className="pull-right">
					{userPermissions != "Read" && (
						<>
							<div
								className="btn btn-success pull-right"
								onClick={() => {
									addNote(agreementId);
								}}
							>
								<SolidIcons.PlusIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left" }}>Add Note</div>
							</div>
							<button
								className="btn btn-success pull-right"
								style={{ marginRight: 10 }}
								onClick={() => {
									sendInvite(agreementId);
								}}
								disabled={setUpStatus || sendingInvite || previouslySentInvite}
							>
								<Tooltip
									content={"Cannot invite Employees during Setup"}
									isOpen={setUpStatus ? undefined : false}
									arrowSize={4}
									distance={10}
								>
									{sendingInvite ? (
										<>
											<Spinner
												style={{
													width: "1.5rem",
													height: "1.5rem",
													verticalAlign: "middle",
													float: "left",
												}}
												className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
											/>
											<div style={{ float: "left", paddingLeft: 5 }}>Inviting Employee</div>
										</>
									) : (
										<>
											<SolidIcons.UserPlusIcon style={{ height: "1.5em", float: "left" }} />
											<div style={{ float: "left", paddingLeft: 5 }}>
												{previouslySentInvite ? "Invite Sent!" : "Invite Employee"}
											</div>
										</>
									)}
								</Tooltip>
							</button>
							<IntegrationResyncEmployee disabled={userPermissions == "Read"} />
						</>
					)}
					{mfaPermissions != "None" && mfaEnabled && (
						<div
							className={`btn ${employeeHasMFA ? "btn-success" : "btn-default"} pull-right`}
							onClick={() => {
								if (mfaPermissions == "Read" || !employeeHasMFA) return;
								openMFAModal();
							}}
							style={{ marginRight: 10 }}
						>
							<OutlineIcons.DevicePhoneMobileIcon style={{ height: "1.5em", float: "left" }} />
							<div style={{ float: "left" }}>MFA {employeeHasMFA ? "Activated" : "Pending"}</div>
						</div>
					)}
					{isAdmin && (
						<div
							className="btn btn-default pull-right"
							onClick={() => copyToClipboard(employee.id)}
							style={{ marginRight: 10 }}
						>
							<OutlineIcons.ClipboardIcon style={{ height: "1.5em", float: "left" }} />
							<div style={{ float: "left" }}>Copy ID</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const agreementId = state.employee?.employeeDetails?.id;
	const agreementInfo = state.employee?.agreementInfo;

	const terminationDate = agreementInfo?.terminationDate;
	const engagementDate = agreementInfo?.engagementDate;
	const userPermissions = state?.permissions?.my?.permissions?.people;

	const currentDepartment = state?.company?.settings?.departments?.find?.(
		(obj) => state?.employee?.departments?.[state.employee.departments.length - 1]?.department == obj?.id,
	);
	return {
		agreementId,
		employee: state.employee?.agreementInfo,
		employeeHasMFA: state.employee?.agreementInfo?.hasMFA,
		role: state.employee?.roles?.[state.employee.roles.length - 1],
		department: currentDepartment,
		engagementDate: engagementDate && new Date(engagementDate),
		terminationDate: terminationDate && new Date(terminationDate),
		isAdmin: state?.my?.profile?.isAdmin,
		userPermissions,
		mfaPermissions: state.permissions?.my?.permissions?.mfa,
		mfaEnabled: state.company?.settings?.mfaRequirement == 2,
		setUpStatus: state?.company?.settings?.status === "Setup",
		sendingInvite: state?.employee?.sendingInvite,
		previouslySentInvite: state?.employee?.sentInvite == agreementId,
	};
};

const mapDispatchToProps = (dispatch) => ({
	addNote: (agreementId) => dispatch(ACTIONS.showNoteDetail({ show: true, item: { agreementId } })),
	sendInvite: (agreementId) => dispatch(EMPLOYEEACTIONS.sendInvite(agreementId)),
	openMFAModal: () => dispatch(EMPLOYEEACTIONS.mfaStatusModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Employee);
